import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Banner from '../../atoms/Banner/Banner';
import Image from '../../atoms/Image/Image';
import Typography from '../../atoms/Typography/Typography';
import ContentBox from '../../molecules/ContentBox';

const bd = {
  imgSrc: '/images/image/message title@2x.png',
  imgSrcM: '/images/image/messagem title@2x.png',
  title: 'Message',
  text1: 'BEST of the BEST',
  text2: 'Developing the Next Generation of Top Security Leaders in Korea',
};

const msg = [
  `Under the mandate of the ‘Resolution of National Security Difficulties Through Talented
Human Resource Development in Information Security,’ the Korea Information
Technology Research Institute (KITRI) has performed various projects in human resource
development in information security from 2010. Since 2012, the institute has been
conducting the “Best of the Best (BoB)” Program to develop the next generation top
security leaders in Korea.`,
  `As the number of trainees and mentors have increased by more than double,
continuous development of the institution including the expansion of the training
center have been achieved. Also, famous Korean and international media report on the
excellent quality of the program so that the institution’s recognition has extended to the
international level. Especially, the competition rate for the 3rd BoB entrance test was
9:1 surprisingly showing that BoB has now become the dream of all dreamers desiring
to be information security experts.`,
  `Until now, BoB has developed about 300 talents in information security through
the 1st, 2nd and 3rd periods.
And BoB graduates not only start their businesses in the information
security sector, but also show their prominence by reporting countlessly
many weak points, presenting theses and winning in the world’s top level competitions
such as DEFCON and CODEGATE.`,
  `Especially, in the 4th BoB, the Grand Prix System was initiated and the ‘Information
Protection Specialty Soldier’ track added as a part of the Civilian and Military Connection Course.
Also, English training for the information security has opened so that the
training program has become more extensive while the quality is reinforced.`,
  `I would like to point out to future BoB trainees that you should trust yourself as
excellent leaders in information technology and the future of the nation and show us
your young passion and challenging spirit by always performing your best while keeping
your patriotism, sense of your duty, responsibility and dignity.`,
  `Thank you.`,
];
const messageImg = '/images/image/message_img.jpg';
export default function MessagePage() {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Banner bannerData={bd} />
      <ContentBox backgroundColor='#f7f7fc'>
        <Box className={classes.inner}>
          <Box className={classes.msgBox}>
            {msg.map((m, i) => {
              return (
                <pre className={classes.msg} key={i}>
                  {m}
                </pre>
              );
            })}
          </Box>
          <Box className={classes.imgBox}>
            <Typography className={classes.imgText}>President, Korea Information Technology Research Institute</Typography>
            <Image className={classes.img} src={messageImg} alt='message image' />
          </Box>
        </Box>
      </ContentBox>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {},
  inner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    paddingBottom: '32px',
  },
  msgBox: {
    width: '100%',
    maxWidth: '1280px',
    boxSizing: 'border-box',
    paddingTop: '90px',
    paddingBottom: '100px',
    '@media only screen and (max-width: 1080px)': {
      paddingBottom: '400px',
    },
    '@media only screen and (max-width: 768px)': {
      paddingTop: '16px',
    },
    '@media only screen and (max-width: 510px)': {
      paddingBottom: '440px',
    },
    '@media only screen and (max-width: 495px)': {
      paddingBottom: '464px',
    },
  },
  msg: {
    fontSize: '16px',
    margin: '0',
    whiteSpace: 'pre-wrap',
    marginBottom: '48px',
    '@media only screen and (max-width: 1080px)': {
      fontSize: '24px',
    },
    '@media only screen and (max-width: 768px)': {
      fontSize: '16px',
    },
  },
  imgBox: {
    display: 'flex',
    width: '100%',
    maxWidth: '1280px',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    position: 'absolute',
    bottom: 0,
    marginBottom: '32px',
    boxSizing: 'border-box',
    '@media only screen and (max-width: 1080px)': {
      flexDirection: 'column-reverse',
    },
    '@media only screen and (max-width: 352px)': {
      paddingRight: '0',
    },
  },
  img: {
    width: '324px',
    marginLeft: '216px',
    '@media only screen and (max-width: 425px)': {
      width: '304px',
    },
  },
  imgText: {
    fontSize: '16px',
    '@media only screen and (max-width: 1080px)': {
      fontSize: '24px',
    },
    '@media only screen and (max-width: 768px)': {
      textAlign: 'right',
      fontSize: '16px',
    },
  },
}));
